import MKBox from 'components/MKBox';
import DefaultFooter from 'examples/Footers/DefaultFooter';
import footerRoutes from 'csdd_footer_routes';

const Footer = () => {
  return (
    <MKBox pt={6} mt={6}>
      <DefaultFooter content={footerRoutes} />
    </MKBox>
  );
};
export default Footer;
